import api from './api';

const loyaltyService = {
  // Get user points
  async getUserPoints() {
    try {
      const response = await api.get('/members/points');
      return response.data;
    } catch (error) {
      console.error('Get user points error:', error);
      throw error;
    }
  },

  // Get group details
  async getGroupDetails(groupId) {
    try {
      const response = await api.get(`/members/group/${groupId}`);
      return response.data;
    } catch (error) {
      console.error('Get group details error:', error);
      throw error;
    }
  },

  // Redeem a coupon
  async redeemCoupon(groupId, couponId, customerCouponId, location) {
    try {
      const params = { group_id: groupId };
      if (customerCouponId) {
        params.customer_coupon_id = customerCouponId;
      } else {
        params.coupon_id = couponId;
      }
      if (location) {
        params.lat = location.lat;
        params.lon = location.lon;
        // Browsers report accuracy in meters; it can be missing, so only send a number.
        if (Number.isFinite(location.accuracy)) params.accuracy = location.accuracy;
      }

      const response = await api.post('/members/redeem', params);
      return response.data;
    } catch (error) {
      console.error('Redeem coupon error:', error);
      throw error;
    }
  },

  // Leave a loyalty program
  async leaveProgram(groupId) {
    try {
      const response = await api.post('/members/leave', { group_id: groupId });
      return response.data;
    } catch (error) {
      console.error('Leave program error:', error);
      throw error;
    }
  },

  // Get public group info (no auth required)
  async getPublicGroupInfo(groupId) {
    try {
      const response = await api.get(`/groups/${groupId}/public`);
      return response.data;
    } catch (error) {
      console.error('Get public group info error:', error);
      throw error;
    }
  },
  
  // Public phone enrollment (no auth required)
  async publicPhoneEnroll(id, phone) {
    try {
      const response = await api.post(`/groups/${id}/enroll`, { phone });
      return response.data;
    } catch (error) {
      console.error('Public phone enroll error:', error);
      throw error;
    }
  },
};

export default loyaltyService;